import React from 'react';
import { Link } from 'react-router-dom';
import './ResearchItem.css';

/**
 * 洞察文章展示组件
 * @param {string} title - 文章标题
 * @param {string} summary - 文章摘要
 * @param {string} author - 作者
 * @param {string} date - 发布日期
 * @param {number} readTime - 阅读时间（分钟）
 * @param {string} category - 分类
 * @param {string} image - 封面图片URL
 * @param {string} slug - 文章slug（用于URL）
 */
const ResearchItem = React.memo(({ 
  title, 
  summary, 
  author, 
  date, 
  readTime, 
  category, 
  image, 
  slug 
}) => {
  return (
    <a 
      href={`/insights/${slug}`} 
      className="research-item-card"
      target="_blank"
      rel="noopener noreferrer"
    >
      {image && (
        <div className="research-item-image">
          <img 
            src={image} 
            alt={title}
            loading="lazy"
          />
        </div>
      )}
      <div className="research-item-content">
        <h3 className="research-item-title">{title}</h3>
        <p 
          className="research-item-summary"
          dangerouslySetInnerHTML={{ __html: summary }}
        />
        <div className="research-item-meta">
          <span className="research-item-author">{author}</span>
          <span className="research-item-date">{date?.split('T')[0]}</span>
          {readTime && (
            <span className="research-item-read-time">{readTime} min read</span>
          )}
        </div>
      </div>
    </a>
  );
});

ResearchItem.displayName = 'ResearchItem';

export default ResearchItem;
